// 与 m-form 的保持一致
import _isUndefined from 'lodash/isUndefined'
import _isFunction from 'lodash/isFunction'
import _isBoolean from 'lodash/isBoolean'

export default {
  computed: {
    visible() {
      // 非表单控件形式的组件项，展示 form-item 与否是根据 formValue 有没有值来决定
      if (
        (this.innerConfig.type === 'plain-text' ||
          this.innerConfig.type === 'link') &&
          _isUndefined(this.innerConfig.visible)
      ) {
        return !!this.formValue[this.innerConfig.prop]
      }

      // visible 支持传入函数，用于控件联动
      if (_isFunction(this.innerConfig.visible)) {
        return this.innerConfig.visible({
          formValue: this.formValue,
          formItem: this.innerConfig
        })
      }

      return _isBoolean(this.innerConfig.visible)
        ? this.innerConfig.visible
        : true
    },

    innerConfig() {
      // params 支持传入函数，用于控件联动
      if (_isFunction(this.config.params)) {
        return {
          ...this.config,
          params: this.config.params({
            formValue: this.formValue,
            formItem: this.config // 当前表单控件配置
          })
        }
      }

      // rules 支持传入函数
      if (_isFunction(this.config.rules)) {
        return {
          ...this.config,
          rules: this.config.rules({
            formValue: this.formValue,
            formItem: this.config // 当前表单控件配置
          })
        }
      }

      const params = { ...this.config.params }
      params.value && delete params.value // 删除 value，避免干扰 v-model
      return { ...this.config, params: params }
    },

    formItemStyle() {
      const style = this.innerConfig.style || {}
      if (this.innerConfig.width) {
        style.width = this.innerConfig.width
        if (typeof style.width === 'number') {
          style.width += 'px'
        }
      }
      return style
    }
  }
}
